import { type Role } from 'store/api/authApi';

export const DELETE_USER_ACCOUNT_REASON = 'Removed by admin via Marketplace';

export const EMAIL_ALREADY_IN_USE_MESSAGE = 'Email address is already in use';

export const parseFullName = (fullName: string) => {
    const parts = fullName.trim().split(/\s+/).filter(Boolean);
    if (parts.length <= 1) {
        return { firstName: parts[0] ?? '', lastName: '' };
    }
    return {
        firstName: parts.slice(0, -1).join(' '),
        lastName: parts.at(-1) ?? '',
    };
};

export const formatUserNameLastFirst = (fullName: string) => {
    const { firstName, lastName } = parseFullName(fullName);
    if (!lastName) {
        return firstName;
    }
    return `${lastName}, ${firstName}`;
};

export const formatUserNameFirstLast = (firstName: string, lastName: string) =>
    [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');

/** Zeplin role option copy shown under each role in the Role dropdown. */
export const MARKETPLACE_ROLE_DESCRIPTIONS = {
    marketplace_supplier_admin:
        'View and manage referral activity, complete rebill tasks, document performance, participate in Live Referrals, and manage user access.',
    marketplace_clinical:
        'View referral information, complete rebill tasks, update NBD dates, and document performance.',
    marketplace_contributor:
        'View referral information and perform all referral-related actions, including participating in Live Referrals and creating or managing templates.',
    marketplace_reader: 'View referral information and complete assigned rebill attestations.',
} as const;

export type MarketplaceRoleName = keyof typeof MARKETPLACE_ROLE_DESCRIPTIONS;

export const getMarketplaceRoleSelectValues = (roles: Role[] | undefined) =>
    (roles ?? []).map(({ role_name, display_name }) => ({
        name: display_name,
        secondaryData: MARKETPLACE_ROLE_DESCRIPTIONS[role_name as MarketplaceRoleName] ?? undefined,
    }));

export const getRoleNameForDisplayName = (
    displayName: string | undefined,
    roles: Role[] | undefined,
) => roles?.find((role) => role.display_name === displayName)?.role_name;

/** Auth0 create-user requires a password; generate one when the UI does not collect it. */
export const generateRandomPassword = () => `${crypto.randomUUID().replaceAll('-', '')}!1Zz`;
